import { InfoCircleOutlined } from "@ant-design/icons";
import { GLOB } from "src/util/Glob";

interface Props {
  title: string;
  info: string;
  reason: string;
}

const StateInfo = ({ title, info, reason }: Props) => {
  if (!info && !reason)
    return <></>;

  const decs = <>
    {info ? <p>Health detail: <br />{info}</p> : null}
    {reason ? <p>Ignored reason: <br />{reason}</p> : null}
  </>;

  const openNotification = () => {
    GLOB.app.notification.open({
      title: title,
      description: decs
    });
  };

  return (
    <InfoCircleOutlined onClick={openNotification} />
  );
};

export default StateInfo;